const state = {
  locales: [
    {
      code: "fr",
      label: "Français",
    },
    {
      code: "en",
      label: "English (UK)",
    },
    {
      code: "de",
      label: "Deutsch",
    },
  ],
};

const getters = {
  getDefaultLocale: (state) => {
    return state.locales.filter((element) => element.code === "en")[0];
  },
  getLocales: (state) => {
    return state.locales;
  },
  getAvailableLocales: (state) => {
    return state.locales.map((element) => element.code);
  },
  getGarLocales: (state) => {
    return state.locales.filter((element) =>
      ["fr", "en"].includes(element.code),
    );
  },
};

const actions = {};
const mutations = {};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
